<template>
  <div class="page-head">
    <a href="javascript:;" class="head-logo">
      <img class="logo-100" src="../assets/powerlogo.png" alt="">
    </a>
    <div class="head-menus-div">
      <div class="head-menus">
        <div class="menu-2 menu-index">
          <transition-group name="list" tag="div">
            <router-link class="menu-one" :class="{'active-menu-one': path === '/electricity/ele_source_data'}" to="/electricity/ele_source_data"  v-if="eleStatus > 0" key="o1">源数据</router-link>
            <router-link class="menu-one" :class="{'active-menu-one': path === '/electricity/ele_case'}" to="/electricity/ele_case" key="o2" v-if="eleStatus > 1">方案</router-link>
            <router-link class="menu-one" :class="{'active-menu-one': path === '/electricity/ele_result'}" to="/electricity/ele_result" key="o3" v-if="eleStatus > 1">结果</router-link>
          </transition-group>
        </div>
      </div>
    </div>
    <div class="head-user">
      <div class="user-info" v-if="login">
        <i class="iconfont icon-user"></i>
        <div class="fg-line-2">
        </div>
        <a href="javascript:;" @click="loginOut">安全退出</a>
      </div>
      <div class="user-info" v-else>
        <a href="javascript:;" @click="goLogin">登录</a>
      </div>
    </div>
    <div style="display: none">
      {{path}}
    </div>
  </div>
</template>

<script>
  export default {
    computed: {
      login: {
        get () {
          return this.$store.getters.login
        }
      },
      path: {
        get () {
          return this.$store.state.route.path
        }
      },
      eleStatus: {
        get () {
          return this.$store.getters.eleStatus
        }
      }
    },
    methods: {
      loginOut () {
        this.$store.dispatch('loginOut')
      },
      goLogin () {
        this.$store.dispatch('setLoginFor', this.path)
        this.$router.push('/login')
      }
    }
  }
</script>

<style scoped lang="less">
  @import '../style/base.less';
  @left-right-width: 13em;
  .menu-index {
    height: 2.63em;
    .menu-one {
      margin: 2px 4em 0;
      font-size: 1.2em;
    }
    .active-menu-one {
      color: @line-color;
      border-bottom: 0.31em solid @line-color;
      padding-bottom: 0.6em;
    }
  }
  .page-head {
    height: 6.13em;
    background-color: @bak-color-1;
    display: flex;
    flex-direction: row;
  }
  .head-logo {
    width: @left-right-width;
    align-items: flex-end;
    justify-content: center;
    display: flex;
    padding: 0 0 0.1em 0.5em;
  }
  .logo-100 {
    height: 5rem;
    margin-left: 1rem;
  }
  .head-menus-div {
    flex: 1;
    display: flex;
    flex-direction:column-reverse;
  }
  .list-enter-active, .list-leave-active {
    transition: all 1s;
  }
  .list-enter, .list-leave-to {
    opacity: 0;
  }
  .head-menus {
    color: #fff;
    display: flex;
    flex-direction:row;
    justify-content:center;
  }
  .head-user {
    width: @left-right-width;
  }
  .fg-line {
    width: 2px;
    margin:-0.31em 1.625em 1.13em;
    background-color: #fff;
  }
  .fg-line-2 {
    width: 2px;
    margin:0.625em 0.44em;
    background-color: #fff;
  }
  .menu-1 {
    transition: 0.3s;
    display: flex;
    flex-direction:row;
    margin: 0 0.625em;
    color: #fff;
    line-height: 1;
    padding-bottom: 1.13em;
    .iconfont {
      font-size: 1.56em;
    }
    span {
      font-size: 1.5em;
      margin-left: 0.625em;
    }
  }
  .menu-1-active {
    color: @line-color;
  }
  .menu-2 {
    display: flex;
    flex-direction:row;
  }
  .menu-one {
    transition: 0.3s;
    color: #fff;
    flex: 1;
    font-size: 0.9em;
    word-break: keep-all;
    white-space: nowrap;
    margin: 2px 0.625em 0;
  }
  .active-menu-one {
    color: @line-color;
    border-bottom: 0.31em solid @line-color;
    padding-bottom: 1.15em;
  }
  .head-user {
    display: flex;
    flex-direction:column-reverse;
  }
  .user-info {
    margin:0 1.88em 0.94em 0;
    color: #fff;
    display: flex;
    flex-direction:row;
    justify-content: flex-end;
    a {
      color: #fff;
      margin-top: 0.44em;
    }
    i {
      font-size: 2.06em;
    }
  }
</style>



// WEBPACK FOOTER //
// PageHeadEle.vue?30470456